import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { HttpErrorMapper } from '../errors/http-error.mapper';
import { TelemetryService } from '../../observability/telemetry.service';

export const telemetryInterceptor: HttpInterceptorFn = (request, next) => {
  const telemetry = inject(TelemetryService);
  const errorMapper = inject(HttpErrorMapper);
  const startedAt = performance.now();
  const safeUrl = toSafeUrl(request.url);

  return next(request).pipe(
    tap({
      next: (event) => {
        if (event instanceof HttpResponse) {
          telemetry.trackHttpRequest({
            method: request.method,
            url: safeUrl,
            status: event.status,
            durationMs: performance.now() - startedAt,
            succeeded: true,
          });
        }
      },
      error: (error: unknown) => {
        const status = error instanceof HttpErrorResponse ? error.status : 0;
        telemetry.trackHttpRequest({
          method: request.method,
          url: safeUrl,
          status,
          durationMs: performance.now() - startedAt,
          succeeded: false,
          errorKind: errorMapper.classify(error),
        });
      },
    })
  );
};

function toSafeUrl(rawUrl: string): string {
  try {
    const parsed = rawUrl.startsWith('/')
      ? new URL(rawUrl, window.location.origin)
      : new URL(rawUrl);

    return `${parsed.origin}${parsed.pathname}`;
  } catch {
    const withoutQuery = rawUrl.split('?')[0] ?? rawUrl;
    return withoutQuery.split('#')[0] ?? withoutQuery;
  }
}
